module.exports = __webpack_public_path__ + "img/split.bb615220.svg";